export const ROUTE_KEYS = {
  HOME: '/',
  BUSCAR_X_PAQUETES: '/buscarxpaquetes',
  CONSULTA: '/consulta',
  CONSULTA_DETALLE: '/consultaDetalle',
  PAQUETE: '/paquete',
  PAQUETES: '/paquetes',
  SALIDA: '/salida',
  BUSCAR_X_VUELOS: '/buscarxvuelos',
  BUSCAR_X_VUELOS_RESERVA: '/reservarxvuelo',
  BUSCAR_X_HOTELES: '/buscarxhoteles',
  BUSCAR_X_HOTELES_DETALLE: '/buscarxhoteles/detalle',
  AGENCIES: '/agencies',
  CLAIMS: '/claims',
  PAY_METHODS: '/pay-methods',
  PRIVACY_POLICY: '/privacy-policy',
  GENERAL_CONDITIONS: '/general-conditions',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  ARREPENTIMIENTO: '/arrepentimiento',
  CUSTOM_SECTION: '/custom',
};

const DAY_SHORT = 'DD/MM/YYYY';
const TIME = 'HH:mm';
const TIME_MERIDIEM = 'LT';
const ISO = 'YYYY-MM-DD';
const NUMBER_MONTHNAME_YEAR = 'D [de] MMMM [de] YYYY';
const FLIGHT = 'DD ddd HH:mm';

export const DATE_KEYS = {
  FORMAT: {
    ISO,
    DAY_SHORT,
    FULL_TIME: `${DAY_SHORT} ${TIME}`,
    YEAR: 'YYYY',
    MONTH_YEAR: 'MMMM YYYY',
    TIME,
    TIME_MERIDIEM,
    NUMBER_MONTHNAME_YEAR,
    FLIGHT,
  },
};

export const TO_LOCAL_STRING_FORMAT_DATE_OPTIONS = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

export const KEY_KEYS = {
  BACKSPACE: 'Backspace',
};

export const dataDefaultValues = {
  data: [],
  error: false,
  isLoading: false,
};

export const COLOR_KEYS = {
  DEFAULT_BACKGROUND: '#144DBE',
  DEFAULT_GREEN: '#8dd3bb',
  DEFAULT_TEXT: '#ffffff',
  DEFAULT_COLOR_GRAY: 'rgb(204, 204, 204)',
  CORAL: 'rgb(237, 108, 2)',
};

export const PAGINATION_KEYS = {
  PAGE: 1,
  PAGE_SIZE: 10,
};

export const SESSION_STORAGE_KEYS = {
  PACKAGE_ADVICE: 'packageAdvice',
  CACHE_STATUS: 'CACHE_STATUS',
  SEARCH_PARAMETERS: 'searchParameters',
  APPLICATION_STATE: 'applicationState',
  FLIGHT_SEARCH_STATE: 'flightSearchState',
};

export const PACKAGE_CARD_TABS_KEYS = {
  HOTELS: 'HOTELS',
  FLIGHTS: 'FLIGHTS',
};

export const FALLBACK_IMAGE =
  'https://res.cloudinary.com/travelit/image/upload/v1715261835/img-test/yhjpgrelyuu3z8ixbwao.jpg';

export const HOTELS_PAGE_FILTER_NAME = 'hotelsPage';

export const TAB_ITEMS = {
  ITINERARY: 'ITINERARY',
  INCLUDES: 'INCLUDES',
  HOTELS: 'HOTELS',
  RATES: 'RATES',
  DEPARTURE: 'DEPARTURE',
  DETAIL: 'DETAIL',
};

export const USDColor = '#118C4F';

export const CACHE_DEFAULTS = {
  DEFAULT_EXPIRATION_TIME: 10 * 60 * 1000, // 10 minutos en milisegundos
};

export const EXTERNAL_URLS = {
  ARGENTINA_CONSUMER_DEFENSE:
    'https://www.argentina.gob.ar/produccion/defensadelconsumidor/formulario',
};
